import React, { useState, useEffect } from "react";
import { message, Input } from "antd";
import http from "../../../../../services/http";
const { TextArea } = Input;

export const SugestoesComo = ({ idSugestao }) => {
	const [descricao, setDescricao] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (idSugestao > 0) {
			listarSugestoesComo(idSugestao);
		}
	}, [idSugestao]);

	// LISTAR COMO
	const listarSugestoesComo = async (id_sugestao) => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_mensagens/carregar/${id_sugestao}?tipo=2`, []);
		if (api.statusCode === 200) {
			setDescricao(api?.response?.data?.texto);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// ADICIONAR COMO
	const salvarSugestoesComo = async (descricao) => {
		setLoading(true);
		const form = {
			id_sugestoes: idSugestao,
			texto: descricao ?? "",
			tipo: 2,
		};
		const api = await http("post", `v1/sugestoes_mensagens/adicionar`, form);
		if (api.statusCode === 200) {
			message.success("Alteração atualizada!");
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	return (
		<TextArea
			disabled={loading}
			rows={10}
			onChange={(e) => setDescricao(e?.target?.value)}
			value={descricao}
			onBlur={() => salvarSugestoesComo(descricao)}
			placeholder="Informe a descrição"
		/>
	);
};
